import { useEffect, useRef, useState, cloneElement } from "react";

// Measures its own box with a ResizeObserver and renders the Recharts chart
// child with explicit numeric width/height (no ResponsiveContainer), so the
// chart is never rendered at width(-1)/height(-1) — eliminating the console warnings.
export function ChartBox({ height = 288, children }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setWidth(Math.floor(el.getBoundingClientRect().width));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ height, width: "100%" }}>
      {width > 0 && cloneElement(children, { width, height })}
    </div>
  );
}
